import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import Icon from 'Pods/Shared/Icon/Icon'

import emptyImage from 'images/no_image_thumb_square.png'

function ListItem({ active, data = {
  image: '',
}, selectJob }) {
  return (
    <div
      className={active === data.title ? 'jobs-list__item is-active' : 'jobs-list__item'}
      onClick={() => selectJob(data.title)}
    >
      <img src={data.image ? data.image : emptyImage} alt={data.title} className="jobs-item__thumb" />
      <div className="jobs-item__contents">
        <div className="jobs-item__header">
          <div className="jobs-item__main-info">
            <div className="jobs-item__title">
              {data.title}
              {data.type === 'initiated_by_buyer'
                && <Icon type={['fas', 'star']} color="green-dark" />
              }
            </div>
            <div className="jobs-item__formats">
              <small>
                <strong>Formats: </strong>
                {data.formats.join(', ')}
              </small>
            </div>
          </div>
          <div className="jobs-item__budget">{numeral(data.budget).format('$0')}</div>
        </div>
        <div className="jobs-item__footer">
          {data.deadline_date}
          {data.applicants_number > 0 ? (
            <span>
              <span className="jobs-item__separator">|</span> {data.applicants_number} applicants
            </span>
          ) : ('')}
        </div>
      </div>
      <div className="job-list__border-bottom" />
      <div className="job-list__border-top" />
    </div>
  )
}

ListItem.propTypes = {
  active: PropTypes.string.isRequired,
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    image: PropTypes.string,
    formats: PropTypes.array.isRequired,
    budget: PropTypes.number.isRequired,
    deadline_date: PropTypes.string.isRequired,
    applicants_number: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  selectJob: PropTypes.func.isRequired,
}

export default ListItem
